<template>
    <UiModalMobile
        :isOpen="isOpen"
        @close="$emit('close')"
    >
        <template #content>
            <div>
                <fieldset class="flex flex-col gap-6">
                    <legend class="sr-only">Sorting options</legend>

                    <!-- Card name A-Z option -->
                    <label
                        class="flex items-center gap-2 cursor-pointer group"
                        @click="updateSortOption('card_title', 'asc')"
                    >
                        <div class="relative flex items-center">
                            <input
                                type="radio"
                                name="sortOption"
                                value="name_asc"
                                class="absolute opacity-0"
                                :checked="isSortChecked('card_title', 'asc')"
                            />
                            <span
                                :class="[
                                    isSortChecked('card_title', 'asc')
                                        ? 'bg-10x-orange'
                                        : 'bg-white dark:bg-slate-800 border border-slate-300',
                                    'w-4 h-4 rounded-lg flex items-center justify-center',
                                ]"
                            >
                                <span
                                    v-if="isSortChecked('card_title', 'asc')"
                                    class="w-1.5 h-1.5 bg-white dark:bg-slate-800"
                                ></span>
                            </span>
                        </div>
                        <span
                            class="text-base text-slate-800 dark:text-slate-100 group-hover:text-slate-900"
                        >
                            Card name A-Z
                        </span>
                    </label>

                    <!-- Card name Z-A option -->
                    <label
                        class="flex items-center gap-2 cursor-pointer group"
                        @click="updateSortOption('card_title', 'desc')"
                    >
                        <div class="relative flex items-center">
                            <input
                                type="radio"
                                name="sortOption"
                                value="name_desc"
                                class="absolute opacity-0"
                                :checked="isSortChecked('card_title', 'desc')"
                            />
                            <span
                                :class="[
                                    isSortChecked('card_title', 'desc')
                                        ? 'bg-10x-orange'
                                        : 'bg-white dark:bg-slate-800 border border-slate-300',
                                    'w-4 h-4 rounded-lg flex items-center justify-center',
                                ]"
                            >
                                <span
                                    v-if="isSortChecked('card_title', 'desc')"
                                    class="w-1.5 h-1.5 bg-white dark:bg-slate-800"
                                ></span>
                            </span>
                        </div>
                        <span
                            class="text-base text-slate-800 dark:text-slate-100 group-hover:text-slate-900"
                        >
                            Card name Z-A
                        </span>
                    </label>

                    <!-- Date opened (newest) option -->
                    <label
                        class="flex items-center gap-2 cursor-pointer group"
                        @click="updateSortOption('date_opened', 'desc')"
                    >
                        <div class="relative flex items-center">
                            <input
                                type="radio"
                                name="sortOption"
                                value="date_desc"
                                class="absolute opacity-0"
                                :checked="isSortChecked('date_opened', 'desc')"
                            />
                            <span
                                :class="[
                                    isSortChecked('date_opened', 'desc')
                                        ? 'bg-10x-orange'
                                        : 'bg-white dark:bg-slate-800 border border-slate-300',
                                    'w-4 h-4 rounded-lg flex items-center justify-center',
                                ]"
                            >
                                <span
                                    v-if="isSortChecked('date_opened', 'desc')"
                                    class="w-1.5 h-1.5 bg-white dark:bg-slate-800"
                                ></span>
                            </span>
                        </div>
                        <span
                            class="text-base text-slate-800 dark:text-slate-100 group-hover:text-slate-900"
                        >
                            Date opened (newest first)
                        </span>
                    </label>

                    <!-- Date opened (oldest) option -->
                    <label
                        class="flex items-center gap-2 cursor-pointer group"
                        @click="updateSortOption('date_opened', 'asc')"
                    >
                        <div class="relative flex items-center">
                            <input
                                type="radio"
                                name="sortOption"
                                value="date_asc"
                                class="absolute opacity-0"
                                :checked="isSortChecked('date_opened', 'asc')"
                            />
                            <span
                                :class="[
                                    isSortChecked('date_opened', 'asc')
                                        ? 'bg-10x-orange'
                                        : 'bg-white dark:bg-slate-800 border border-slate-300',
                                    'w-4 h-4 rounded-lg flex items-center justify-center',
                                ]"
                            >
                                <span
                                    v-if="isSortChecked('date_opened', 'asc')"
                                    class="w-1.5 h-1.5 bg-white dark:bg-slate-800"
                                ></span>
                            </span>
                        </div>
                        <span
                            class="text-base text-slate-800 dark:text-slate-100 group-hover:text-slate-900"
                        >
                            Date opened (oldest first)
                        </span>
                    </label>
                </fieldset>
            </div>
        </template>
        <template #footer>
            <div class="px-6 py-1 pb-8 bg-white dark:bg-slate-800">
                <button
                    class="w-full px-4 py-2.5 bg-slate-900 text-white rounded shadow text-sm font-medium hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2"
                    @click="$emit('close')"
                >
                    Apply
                </button>
            </div>
        </template>
    </UiModalMobile>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useWalletStore } from '@/store/wallet';
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['close']);

const walletStore = useWalletStore();
const { sortBy, sortDirection } = storeToRefs(walletStore);
const { setSortBy } = walletStore;

const isSortChecked = (column, direction) => {
    return sortBy.value === column && sortDirection.value === direction;
};

const updateSortOption = (sortKey, direction) => {
    setSortBy(direction, sortKey);
};
</script>
